import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import {
  Constants,
  ProviderClass,
  UiZoneWidgetAttributeConfig,
} from '@finxone-platform/shared/sys-config-types';
import { ValidationConfig } from '@finxone-platform/ui-components';
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
@Component({ standalone: false, selector: 'finxone-web-frontend-date', templateUrl: './date.component.html' })
export class DateComponent implements OnInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  @Output() dateChanges = new EventEmitter<any>();
  @Input() dayValidators = [Validators.max(31), Validators.min(1)];
  @Input() yearValidators = [Validators.max(new Date().getFullYear())];
  @Input() day = 1;
  @Input() month = 1;
  @Input() year: number = new Date().getFullYear();
  @Input() dayFieldValidationConfig: ValidationConfig[] = [];
  @Input() yearFieldValidationConfig: ValidationConfig[] = [];
  public selectedMonth: { name: string; key: number } | undefined;
  public allMonths = Constants.allMonths;
  public dateForm: FormGroup;

  constructor(public dataIn: ProviderClass<UiZoneWidgetAttributeConfig>) {}

  ngOnInit(): void {
    this.buildForm();
    this.dateForm.patchValue(
      {
        day: this.day ?? '',
        month: this.month ?? '',
        year: this.year ?? '',
      },
      { emitEvent: true },
    );
    this.formatDateObject(this.dateForm.value);
    this.listenToChanges();
  }

  private listenToChanges() {
    this.dateForm.valueChanges
      .pipe(takeUntil(this.destroy$), debounceTime(300), distinctUntilChanged())
      .subscribe((value) => {
        this.formatDateObject(value);
      });
  }

  private getSelectedMonthName() {
    const monthValue = this.dateForm.get('month')?.value;
    this.selectedMonth = this.allMonths?.find((month) => month.key === monthValue);
  }

  public formatDateObject(
    dateValue: Partial<{ day: string | null; month: string | null; year: string | null }>,
  ) {
    const date = {
      day: Number(dateValue.day) ?? 0,
      month: (Number(dateValue?.month) ?? 0) + 1,
      year: Number(dateValue.year) ?? '',
    };
    this.getSelectedMonthName();
    this.dateChanges.emit(date);
  }

  private buildForm() {
    this.dateForm = new FormGroup({
      day: new FormControl('', this.dayValidators),
      month: new FormControl(''),
      year: new FormControl('', this.yearValidators),
    });
  }

  public getErrorMessage(validator: ValidationConfig): string {
    if (validator.message) {
      let message = validator.message;
      if (validator.params) {
        Object.keys(validator.params).forEach((key) => {
          message = message.replace(`{${key}}`, validator.params[key]);
        });
      }
      return message;
    }
    return '';
  }
}
